module.exports = __webpack_public_path__ + "img/zixun_4@2x.24002516.png";